import React, { FC, useEffect, useState } from 'react';
import { Header } from 'components/Header';

// import { routes, IRoute } from 'layouts/routes';
import Sidebar from 'components/Sidebar';
import SecondaryView from 'components/SecondaryView';
import { useDispatch } from 'react-redux';
import api from 'services/api';
import { handleChannelList } from 'store/channelsSlice';
import { isChrome, isMobile, isMobileOnly, isSafari } from 'react-device-detect';
import { useParams, useNavigate } from 'react-router-dom';
import useActiveWorkspace from 'hooks/useActiveWorkspace';
import _ from 'lodash';

import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { BitmovinPlayerProvider } from 'context/BitmovinContext';

const MainLayout: FC = ({ children }) => {
  const dispatch = useDispatch();
  const [bottomBarHeight, setBottomBarHeight] = useState<number>(0);

  const { workspaceArray, sessionWorkspace, getWorkspace } = useActiveWorkspace();
  const { workspaceId } = useParams();
  const secondaryViewVideos = useSelector((state: RootState) => state.secondaryChannelVideos);

  const channelIdRegex = /\/channel\/([^/]+)/;
  const channelMatch = location.pathname.match(channelIdRegex);
  const channelId = channelMatch ? channelMatch[1] : 'home';

  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (workspaceArray.length) {
      const exists = workspaceArray.some((ws: any) => ws.workspace_id === workspaceId);
      if (!exists) {
        console.log('workspace param not exist', workspaceId);
        navigate(`/workspace/${sessionWorkspace}/videos/all`);
      } else {
        const ws = getWorkspace(workspaceId);
        sessionStorage.setItem('workspace', ws.workspace_id);
        sessionStorage.setItem('workspace-url', ws.url);
        localStorage.setItem('last-active:workspace', ws.workspace_id);
      }
      setIsLoaded(true);
    }
  }, [workspaceArray, navigate, workspaceId]);

  useEffect(() => {
    if (isLoaded) {
      window.addEventListener('storage', (event: any) => {
        if (event.key === 'workspaces') {
          const newWorkspaces = JSON.parse(event.newValue);
          const sessionId = sessionStorage.getItem('workspace');
          const workspaceSession = _.find(newWorkspaces, { workspace_id: sessionId });
          if (!workspaceSession) {
            console.log('User logged out in another tab.');
            const workspaceUrl = sessionStorage.getItem('workspace-url');
            setTimeout(() => {
              sessionStorage.clear();
              window.location.replace(workspaceUrl + '/logout');
            }, 2000);
          }
        }
      });
    }
  }, [workspaceArray]);

  // const route = routes.find((el: IRoute) => {
  //   return el.url === location.pathname;
  // });

  // const headerDisplay = route?.hasHeader && (
  //   <Header
  //   // query={searchTerms}
  //   // results={filtered}
  //   // onSearchTerms={handleSearchTerm}
  //   // onSearch={handleSearch}
  //   // disabled={!active}
  //   />
  // );

  useEffect(() => {
    if (isMobileOnly) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isMobileOnly]);

  useEffect(() => {
    let mounted = true;
    api.get(`/api/users/channels/`).then((res) => {
      if (mounted) {
        dispatch(handleChannelList(res.data));
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      // Get the height of the window
      const windowHeight = window.innerHeight;

      // Get the height of the document body
      const bodyHeight = document.body.clientHeight;

      // Calculate the bottom bar height
      const calculatedBottomBarHeight = windowHeight - bodyHeight;

      // Set the bottom bar height in state
      setBottomBarHeight(calculatedBottomBarHeight);
    };

    // Attach the resize event listener
    window.addEventListener('resize', handleResize);

    // Initial calculation on mount
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const mobileCss = () => {
    if (isChrome) {
      return 110;
    } else if (isSafari) {
      return 85;
    }
  };

  return (
    <>
      <div
        className={`${isMobileOnly ? 'mobile' : ''} flex flex-col`}
        style={{
          height: isMobileOnly ? `${window.innerHeight}px` : '100vh'
        }}
      >
        <Header />
        <div className="flex grow">
          <Sidebar />
          <div className="w-full flex-1 min-w-0 font-lato">
            <div className="flex h-full">
              <div className="w-full h-full">
                <BitmovinPlayerProvider>{children}</BitmovinPlayerProvider>
              </div>
              {secondaryViewVideos.channels[channelId] && <SecondaryView />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { MainLayout };
